var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNotificationText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notification-text"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M22 8H15.6C12.2397 8 10.5595 8 9.27606 8.65396C8.14708 9.2292 7.2292 10.1471 6.65396 11.2761C6 12.5595 6 14.2397 6 17.6V32.4C6 35.7603 6 37.4405 6.65396 38.7239C7.2292 39.8529 8.14708 40.7708 9.27606 41.346C10.5595 42 12.2397 42 15.6 42H30.4C33.7603 42 35.4405 42 36.7239 41.346C37.8529 40.7708 38.7708 39.8529 39.346 38.7239C40 37.4405 40 35.7603 40 32.4V26M26 34H14M30 26H14",
    stroke: "#000A66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    opacity: 0.3,
    d: "M40.2426 7.75736C42.5858 10.1005 42.5858 13.8995 40.2426 16.2426C37.8995 18.5858 34.1005 18.5858 31.7574 16.2426C29.4142 13.8995 29.4142 10.1005 31.7574 7.75736C34.1005 5.41421 37.8995 5.41421 40.2426 7.75736Z",
    stroke: "#000A66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNotificationText);
export default __webpack_public_path__ + "static/media/ic-notification-text.9dd5e4dbc2e107c3266f4773b3ef4e57.svg";
export { ForwardRef as ReactComponent };